import React from 'react'

const resultsContext = React.createContext({
    resultsPartner: "",
    setResultsPartner: () => {},
})

export default resultsContext;